<template>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <dx-data-grid ref='refInspection'
        :data-source='inspectionInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        @focused-row-changed="onSelectionChanged"
        :auto-navigate-to-focused-row="false"
        key-expr="seqId"
        :focused-row-key.sync='focusedRowKey'
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="exportFileName"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxEditing
          :allow-deleting="false"
          :allow-updating="false"
          :allow-adding="false"
          :use-icons="true"
          mode="row"
        />
        <DxColumn
          :allowEditing='false'
          caption="입고일자"
          data-field="입고일자"
          dataType= 'date'
          format='yyyy-MM-dd'
          width="100"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="입고시간"
          data-field="입고시간"
          alignment="center"
          width="70"
          :visible="false"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="공급처"
          data-field="거래처코드"
          :visible='true'
          sort-order="asc"
        >
           <DxLookup
            :data-source="partnersLookup"
            display-expr="거래처명"
            value-expr="거래처코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품번"
          data-field="품번"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품명"
          data-field="품명"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
          :visible='false'
        >
          <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="입고수량"
          data-field="입고수량"
          format='#,##0'
          dataType="number"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="규격"
          data-field="규격"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="체결성"
          data-field="체결성"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="외관"
          data-field="외관"
          :visible='true'
        >
        </DxColumn>
        <DxColumn type="buttons"
          caption="합격/불합격"
        >
          <DxButton
            text="합격"
            icon="check"
            type="default"
            :on-click="onCheckTrue"
          />
          <DxButton
            text="불합격"
            type="danger"
            icon="remove"
            :on-click="onCheckFalse"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="합격"
          data-field="판정"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="검사일시"
          data-field="updateTime"
          dataType= 'datetime'
          format='yyyy-MM-dd HH:mm'
          width="110"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="LOT NO"
          data-field="lotNo"
           width="200"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="부적합내용"
          data-field="부적합내용"
          :visible='true'
          width="220"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="조치내용"
          data-field="조치내용"
          :visible='true'
           width="220"
        >
        </DxColumn>
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="입고일자"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
</template>

<script>
import Loading from 'vue-loading-overlay'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel,
  DxLookup, DxEditing, DxButton } from 'devextreme-vue/data-grid'

export default {
  name: 'HardwareInspection',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      inspectionInfoList: null,
      exportFileName: null,
      focusedRowKey: null,
      inspectionDateFrom: null,
      meterialTypeLookup: null,
      partnersLookup: null,
      updateArray: []
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxLookup,
    DxEditing,
    DxButton
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.inspectionDateFrom = AppLib.getToday()
    this.inspectionDateTo = AppLib.getToday()
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.partnersLookup = this.$store.getters.getPartnersInfo
    this.refreshInspectionList()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onCheckTrue (e) {
      console.log(e)
      e.row.data.판정 = true
      e.row.data.updateTime = AppLib.getNow()
    },
    onCheckFalse (e) {
      console.log(e)
      e.row.data.판정 = false
      e.row.data.updateTime = AppLib.getNow()
    },
    onRowUpdated (row) {
      if (this.inspectionInfoList.length > 0) {
        this.$_sp.runUpdateSqlProc('수입검사하드웨어', ['seqId'], ['자재유형', '품명', '차종'], this.inspectionInfoList)
          .then((data) => {
            this.$snotify.info('저장 되었습니다.')
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    onSelectionChanged (e) {

    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>입고일자:</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 110,
            value: this.inspectionDateFrom,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              this.inspectionDateFrom = args.value
              if (this.inspectionDateFrom.substring(0, 7) !== this.inspectionDateTo.substring(0, 7)) {
                this.$snotify.info('월단위로만 조회 가능합니다.')
                return
              }
              this.refreshInspectionList()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b>~</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 110,
            value: this.inspectionDateTo,
            type: 'date',
            displayFormat: 'yyyy-MM-dd',
            onValueChanged: (args) => {
              this.inspectionDateTo = args.value
              if (this.inspectionDateFrom.substring(0, 7) !== this.inspectionDateTo.substring(0, 7)) {
                this.$snotify.info('월단위로만 조회 가능합니다.')
                return
              }
              this.refreshInspectionList()
            }
          }
        }
      )
    },
    refreshInspectionList () {
      this.exportFileName = `${this.inspectionDateFrom}-${this.inspectionDateTo}_하드웨어검사`
      const param = {
        시작입고일자: this.inspectionDateFrom,
        종료입고일자: this.inspectionDateTo,
        자재유형: '하드웨어'
      }
      this.$_sp.runNoEncodeFindProc('spFindAllInspectionResultBetweenDate', param)
        .then(data => {
          this.inspectionInfoList = this.$_sp.MakeModel(data)
        })
    }

  }
}
</script>

<style lang="scss">

</style>
